module.exports = __webpack_public_path__ + "0.1.0/img/zxdx.822bfb57.png";